module.exports = __webpack_public_path__ + "static/media/t2.476812da.png";